import { useTranslations } from 'hooks'

export const QuizResult = ({description, img}: QuizResultType): JSX.Element => {
    const [DESC, ECO, CONTACT1, CONTACT2, CONTACT3] = useTranslations(i18n)
    return(
        <div className="quizResult">
            <img src={img} />
            <div className="quizResult-content">
                <p>{description}</p>
                <p>{DESC}</p>
                <br/>
                <p>{ECO} <br/>
            {CONTACT1} <a target="_blank" href='https://www.ecomundo.eu/en/contact-us' className="mdLink">{CONTACT2}</a> {CONTACT3}</p>
            </div>
        </div>
    )
}

type QuizResultType = {
    description?: string
    img?: string
}

const i18n = [
    `MedicalDevice.Result.Description.txt`,
    `MedicalDevice.Result.Ecomundo.txt`,
    `MedicalDevice.ContactUs1.txt`,
    `MedicalDevice.ContactUs2.txt`,
    `MedicalDevice.ContactUs3.txt`
]